// Promoted from golive/components/DataTable/DataTableHeadCell.jsx (unchanged).
import PropTypes from "prop-types";
import { ChevronUp, ChevronDown } from "lucide-react";

const ALIGN = {
  left: "text-left",
  right: "text-right",
  center: "text-center",
};

export default function DataTableHeadCell({
  width = "auto",
  children,
  sorted,
  sortAllowed = true,
  align = "left",
  ...rest
}) {
  const isSortable = sortAllowed && sorted !== undefined;

  return (
    <th
      style={{ width: width !== "auto" ? width : undefined }}
      className={[
        "py-3 px-6 text-xs font-semibold uppercase tracking-wider text-slate-500",
        "bg-gray-50 border-b border-gray-200",
        ALIGN[align] ?? "text-left",
        isSortable ? "cursor-pointer select-none hover:bg-gray-100 transition-colors" : "",
      ].join(" ")}
      {...rest}
    >
      <div className="inline-flex items-center gap-1">
        <span>{children}</span>
        {isSortable && (
          <div className="flex flex-col">
            <ChevronUp size={12} className={sorted === "asc" ? "text-slate-700" : "text-slate-300"} style={{ marginBottom: "-3px" }} />
            <ChevronDown size={12} className={sorted === "desc" ? "text-slate-700" : "text-slate-300"} />
          </div>
        )}
      </div>
    </th>
  );
}

DataTableHeadCell.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  sorted: PropTypes.oneOf([undefined, false, "asc", "desc"]),
  align: PropTypes.oneOf(["left", "right", "center"]),
  sortAllowed: PropTypes.bool,
};
